import { Component, computed, input } from '@angular/core';
import { TelephoneLinkComponent } from '../../../../../../shared/components/telephone-link/telephone-link.component';
import { MmrService } from '../../../../services/mmr.service';
import { ClaimDetailsPanelNotForOnline } from '../../../../types/mmr-claims.type';
import { NoAllocationRulesComponent } from '../no-allocation-rules/no-allocation-rules.component';

@Component({
  selector: 'app-not-for-online',
  imports: [NoAllocationRulesComponent, TelephoneLinkComponent],
  templateUrl: './not-for-online.component.html',
  styleUrl: './not-for-online.component.scss',
})
export class NotForOnlineComponent {
  claimType = input.required<'repair' | 'service'>();

  protected viewModel = computed(() => {
    const { claims } = this.mmrService.planClaimsDetails;
    const claimValue = claims.value()?.[this.claimType()] as ClaimDetailsPanelNotForOnline;

    return {
      claimType: this.claimType(),
      claimValue,
      phone: claimValue?.contactPhone,
      postCode: claims.value()?.addressInformation?.postalCode,
      contentType: claimValue?.contentType,
      furnitureCareWebsite: claimValue?.website,
      furnitureCareWebsiteLabel: claimValue?.website?.replace(/^www\./, ''),
      furnitureCareWebsiteHref:
        claimValue?.website && !claimValue.website.startsWith('www.')
          ? `www.${claimValue.website}`
          : claimValue?.website,
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(private readonly mmrService: MmrService) {}
}
